// extracted by mini-css-extract-plugin
export default {"dlPercentFormatter":"src-js-common-components-formatters-PercentFormatter---dlPercentFormatter---tON6C"};